import { sitesQuery } from '@/api/queries'
import { Portfolio } from '@/components/portfolio/Portfolio'
import { ErrorCard, LoadingCard } from '@/components/ui/StateCards'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@/lib/i18n'

export const Route = createFileRoute('/')({
  component: PortfolioRoute,
})

function PortfolioRoute() {
  const query = useQuery(sitesQuery)

  if (query.isPending) return <LoadingCard label={t('Loading projects…')} shape="cards" />
  if (query.isError) return <ErrorCard message={query.error.message} onRetry={query.refetch} />

  return <Portfolio sites={query.data.sites} />
}
